module.exports = __webpack_public_path__ + "media/src/public/img/popup-heart-4c94db982666778eaa589426e8bd5daf.png";